import { OrderStatus } from "@/common/enum/order-status";
import {
  PaymentStatus,
  paymentStatusDisplayNames,
} from "@/common/enum/payment-status";
import {
  PaymentType,
  paymentTypeDisplayNames,
} from "@/common/enum/payment-type";
import { formatDateToYYYYMMDDhhmm9 } from "@/common/util/date-util";
import { formatCommasNumber } from "@/common/util/format-number-with-commas";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { OrderDetailDto } from "@/types/dto/order-detail-dto";
import { Table } from "flowbite-react";
import { CustomCell } from "../CustomCell";
import AccountInfo from "./AccountInfo";

interface Props {
  orderDetail: OrderDetailDto;
}

export const PartnerOrderPaymentTableRow: React.FC<Props> = ({
  orderDetail,
}) => {
  const payment = orderDetail.payment;
  const isTaxProcessed = orderDetail.status === OrderStatus.TAX_PROCESSED;
  const isPayLater = orderDetail.payment.paymentMethod === PaymentType.PALT;
  const isVirtualPay = orderDetail.payment.paymentMethod === PaymentType.PAVC;

  return (
    <Table.Row className="bg-white text-semantic-text-body">
      <Table.Cell>
        <div className="flex flex-col gap-[4px] p-[16px]">
          <Body14Regular>
            {paymentTypeDisplayNames[payment.paymentMethod]}
          </Body14Regular>
          {((isPayLater && isTaxProcessed) || isVirtualPay) && <AccountInfo payment={payment} />}
        </div>
      </Table.Cell>
      <Table.Cell className="border-l">
        <CustomCell>
          <Body14Regular>{`${formatCommasNumber(
            payment.amount,
          )}원`}</Body14Regular>
        </CustomCell>
      </Table.Cell>
      <Table.Cell className="border-l">
        <div className="flex flex-col justify-center p-[16px]">
          {isPayLater && isTaxProcessed ? (
            <Body14Regular className={"text-semantic-text-error-primary"}>
              세금계산서 발행 완료
            </Body14Regular>
          ) : (
            <>
              <Body14Regular
                className={
                  payment.status === PaymentStatus.PENDING
                    ? "text-semantic-text-error-primary"
                    : "text-semantic-text-body"
                }
              >
                {paymentStatusDisplayNames[payment.status]}
              </Body14Regular>
              {payment.status === PaymentStatus.COMPLETED &&
                payment.completedAt && (
                  <Body14Regular className="text-semantic-text-tertiary">
                    {formatDateToYYYYMMDDhhmm9(payment.completedAt)}
                  </Body14Regular>
                )}
            </>
          )}
        </div>
      </Table.Cell>
      {isPayLater && (
        <Table.Cell className="border-l">
          <CustomCell className="flex flex-col justify-center">
            <Body14Regular className="text-semantic-text-body">
              {isTaxProcessed ? orderDetail.NO_ISS : "발행 전"}
            </Body14Regular>
          </CustomCell>
        </Table.Cell>
      )}
    </Table.Row>
  );
};
